import { Modal } from '//au.fliteboard.com/cdn/shop/t/477/assets/configurator-modal.js?v=183200425955450131601776916266';

class LearnMoreButton extends HTMLElement {
  constructor() {
    super();
    this.modal = document.createElement('x-modal')
  }

   static get observedAttributes() {
    return ["collection","visible","modal-type"];
  }

  get collectionHandle() {
    return this.getAttribute('collection')
  }
  get modalType() {
    return this.getAttribute('modal-type')
  }
  get modalName() {
    return this.getAttribute('button-text')

  }
  get modalVisible() {
    return this.hasAttribute('visible')
  }

  connectedCallback() {
    this._render();
    this._attachEventHandlers();
  }

 _render() {
    this.container = document.createElement("button")
    this.modal.setAttribute('collection-handle',this.collectionHandle)
    this.modal.setAttribute('modal-type',this.modalType)
    this.appendChild(this.modal)
    if(this.modalType == 'buy') {
      this.container.innerHTML = `<span class="configurator-buy-link">See details</span>`
    } else {
      this.container.innerHTML = `<button type="button" class="configurator-info-link">${this.modalName}</button>`
    }

    this.appendChild(this.container)
    if(this.modalVisible){ this.openConfiguratorModal() }
 }

openConfiguratorModal() {
  this.modal.openCollectionModal()
}

_attachEventHandlers() {
  // console.log('Event Handler',this.collectionHandle)
   this.querySelector('button').addEventListener("click", (e) => {
     e.stopImmediatePropagation();
     e.preventDefault();
     this.openConfiguratorModal()
   })
}


}
window.customElements.define("x-modal", Modal);
window.customElements.define("learn-more", LearnMoreButton);

async function getCartProps() {
  var cartContents = await fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  // .then(data => { console.log(data['attributes']); });
}

async function updateCart() {
  var handle = $('body').attr('data-product-handle');
  jQuery.post(window.Shopify.routes.root + 'cart/update.js', "attributes[product-" + handle + "]=" + "Charger/Extras");
}

async function enhanceSelectors() {
  var enhanceGroupSelections = [];
  $('.EnhanceGroup .EnhanceItem').on('click', function(e) {
    e.stopImmediatePropagation(); // Prevents double click
    updateCart();
    // alert('clicked');
  });
}

function addEnhancement() {
  // $('.enhancePortalProduct input[type=checkbox]').on('click', function(el) {
  //   var selectedEnhancementVariantId = $(this).parent().find('select').val(); // .val();
  //   $(this).val(selectedEnhancementVariantId);
  //   $(this).attr('data-product-image', $(this).parent().find('option:selected').data('productImage'));
  //   $(this).attr('data-product-title', $(this).parent().find('option:selected').data('productTitle'));
  //   $(this).attr('data-variant-title', $(this).parent().find('option:selected').data('variantTitle'));
  //   $(this).attr('data-vid', $(this).parent().find('option:selected').data('vid'));
  //   showSelections();
  // });

}


function _attachEventHandlers() {
  document.querySelector('select').addEventListener("change", function (event) {
		showSelections();
	}.bind(this));
   document.getElementById('chargerSelector').addEventListener("click", function (event) {
		showSelections();
	});
  
    document.getElementById('flitecellSelector').addEventListener("click", function (event) {
		showSelections();
	})
}

function showSelections(){
  $('#summaryCharger').empty();
  $('#summaryBattery').empty();
  $('#chargerSelector input:checked').each(function(element) { $('#summaryCharger').append(summaryProduct($(this))) });
  $('#flitecellSelector input:checked').each(function(element) { $('#summaryBattery').append(summaryProduct($(this))) });
}

function summaryProduct(product){ //title, image, variant_id, sub_title){
  return ('<div class=\"SummaryBlock addOn\" value=\"' + product.data('vid') + '\" data-price=\"' + product.data('variantPrice') + '\"><div class="img"><img src=\"' + product.data('productImage') +  '\" /></div><div class="summary-text"><h5>' + product.data('productTitle') + '</h5><p>' + product.data('variantTitle') + '</p></div></div>');
}


async function addAllToCart(){
  var selectedVariant = '';
  var quantity = 1;
  var enhancements = [];
}

function enhanceClick() {
  $('.enhanceBlockClick').on('click', function(e) {
    e.stopImmediatePropagation();
    // e.preventDefault();
    $(this).closest('.enhanceBlock').find('.configurator-buy-link').click();
  })
}
updateCart();
enhanceSelectors();
getCartProps();
showSelections();
addEnhancement();
_attachEventHandlers();

enhanceClick();